export default __webpack_public_path__ + "static/media/ThienNhanResume.0eb299be.pdf";